import { tns } from 'tiny-slider/src/tiny-slider'

export const initializeTestimonialsSlider = () => {
  tns({
    container: '.testimonial--slider',
    controlsPosition: 'bottom',
    navPosition: 'bottom',
    mouseDrag: true,
    controlsContainer: '.slider--controls',
    edgePadding: 16,
    gutter: 60,
    loop: false,
  })
}
